import * as XLSX from 'xlsx';
import ButtonWithIcon from "./ButtonWithIcon.jsx";
import PropTypes from "prop-types";
import {Icons} from "./Icons.jsx";

export const ExportToExcel = ({data, fileName = 'analiza.xlsx', text, variant = 'link', size = 28}) => {
    const handleExport = (data, filename = 'export.xlsx') => {
        const worksheet = XLSX.utils.json_to_sheet(data);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
        const excelBuffer = XLSX.write(workbook, {bookType: 'xlsx', type: 'array'});

        const blob = new Blob([excelBuffer], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
        const url = URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = url;
        link.download = filename;
        link.click();

        URL.revokeObjectURL(url);
    };


    // if (text) return (
    //     <div
    //         onClick={() => handleExport(data, fileName)}
    //     >
    //         {text}
    //     </div>
    // )


    return (

        <ButtonWithIcon
            text={text || ''}
            icon={<Icons.excel size={size}/>}
            title={'Eksportuj do Excel'}
            variant={variant}
            onClick={() => handleExport(data, fileName)}
        />
    );
}

ExportToExcel.propTypes = {
    data: PropTypes.array.isRequired,
    fileName: PropTypes.string,
    text: PropTypes.string,
    variant: PropTypes.string,
    size: PropTypes.number
};